import { render, staticRenderFns } from "./JobPrePublishedPreviewMessageHistory.vue?vue&type=template&id=09a38bd8"
import script from "./JobPrePublishedPreviewMessageHistory.vue?vue&type=script&lang=js"
export * from "./JobPrePublishedPreviewMessageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports